import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { useSelector, useDispatch } from 'react-redux'
import { TextField, Switch } from 'formik-material-ui'
import InputBase from '@material-ui/core/InputBase';
import { Autocomplete } from 'formik-material-ui-lab';
import { makeStyles, useTheme} from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Divider from '@material-ui/core/Divider';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import FormHelperText from '@material-ui/core/FormHelperText';
import MuiTextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Box from '@material-ui/core/Box';
import { MyMess} from '../../App'
import Title from './Title';
import { GlobalSnackBarUtil } from '../../component/GlobalSnackBar';
import { asyncUpdatePassword } from '../../redux/ducks/userDuck';
import { readMerchant, asyncEditMerchant } from '../../redux/ducks/merchant';
import parsePhoneNumber from 'libphonenumber-js';
import {Countries as countries} from '../../utils/CountryList';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'
import { isAlphanumeric, isAlphabet, isAlphanumericWithSymbols, parseCountry, parsePhone} from '../../utils/Utils';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const fields = {
  firstName: {
      required: true,
      isAlphabet: true,
      isAlphanumeric: false,
      isAlphanumericWithSymbols: false,
      maxLength: 100
  },
  lastName:{
      required: true,
      isAlphabet: true,
      maxLength: 100
  },
  phoneNumber:{
      required: true,
      maxLength: 20
  },
  mobileNumber:{
    required: true,
    maxLength: 20
  },
  addr:{
      required: true,
      isAlphanumericWithSymbols: true,
      maxLength: 100
  },
  addr2:{
      required: true,
      isAlphanumericWithSymbols: true,
      maxLength: 100
  },
  city:{
      required: true,
      isAlphabet: true,
      maxLength: 255
  },
  province:{
      required: true,
      isAlphabet: true,
      maxLength: 255
  },
  zipCodeStr:{
      required: true,
      isAlphanumeric: true,
      maxLength: 15
  },
  compName: {
      required: false,
      isAlphanumericWithSymbols: true,
      maxLength: 255
  }
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
  },
  container:{
    display: 'flex',
    flexDirection: 'column',
    padding: 10,
    flex: '1 0 auto',
  },
  formWrapper: {
    paddingTop: 15,
  },
  form: {
    // display: 'flex',
    // flexDirection: 'column',
    // justifyContent: 'center',
    // alignItems: 'center',
    // width: '60%',
    // flex: '1 1 auto'
  },
  fieldBox:{
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    '& label':{
      flex: 1
    }
  },
  phoneFieldBox: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    '& label':{
      flex: 1
    },
    '& .react-tel-input': {
      // width: '100%',
      // margin: 8,
      // flex: 2,
      '& input': {
          background: 'transparent',
          width: '100%',
          paddingTop: 10.5,
          paddingBottom: 10.5
      },
      '& .form-control:focus': {
          borderColor: theme.palette.primary.main,
          boxShadow: '0 0 0 1px ' + theme.palette.primary.main
      }
    }
  },
  phoneInputWrapper: {
    width: '100%',
    margin: 8,
    flex: 2,
  },
  field: {
    flex: 2
  },
  hint: {
    margin: theme.spacing(1),
    fontSize: 16,
  },
  readonlyField: {
    flex: 2,
    paddingTop: 5,
    paddingBottom: 5,
    fontSize: 16,
    margin: '12px 8px',
    color: '#999',
    overflow: 'overlay',
    overflowWrap: 'break-word',
  },
  muiTextField: {
    margin: 8,
    flex: 2,
    '& .MuiTextField-root': {
      margin: theme.spacing(0),
    },
  },
  option: {
    fontSize: 15,
    '& > span': {
      marginRight: 10,
      fontSize: 18,
    },
},
 
}));

export default function Account(){

  const classes = useStyles();
  const dispatch = useDispatch();
  const [isProcessing, setIsProcessing] = useState(false); 
  // const [basicInfo, setBasicInfo] = React.useState({});

  useEffect(() => {
    dispatch(readMerchant(user.email));
  }, []);
  
  const user = useSelector(state => state.user);
  const merchant = useSelector(state => state.merchant);  
 
  const theme = useTheme();
  const [tabIndex, setTabIndex] = React.useState(0);


  const validateHandler = (values) => {

    const errors = {};
    // ['currentPass','newPass', 'confirmPass'].forEach(key => {
    //     if(values[key] && values[key].trim().length === 0){
    //         errors[key] = 'This field is required'
    //     }   
    //  })

    ['firstName','lastName', 'mobileNumber'].forEach(key => {

      let field = fields[key];
      let value = values[key];

      if( field &&  field.required && ( !value || value.trim().length === 0 ) ) {
          errors[key] = MyMess.general.errors.required
      } else if (field.maxLength && value && value.length > field.maxLength) {
          errors[key] = MyMess.formatString(MyMess.general.errors.maxLength, fields[key].maxLength )
      } else if (field.isAlphabet && value &&  !isAlphabet(value, true)) {
          errors[key] = MyMess.general.errors.englishOnly
      } else if (field.isAlphanumeric && value &&  !isAlphanumeric(value, true)) {
          errors[key] = MyMess.general.errors.alphanumericOnly
      } else if (field.isAlphanumericWithSymbols && value &&  !isAlphanumericWithSymbols(value, true)) {
          errors[key] = MyMess.general.errors.alphanumericSymbolOnly
      }
      
    });

    if (values.newPass !== values.confirmPass) {
      errors.confirmPass = MyMess.general.errors.notMatchPassword
    }

    if(values.newPass.trim().length > 0 && values.currentPass.trim().length === 0 ) {
      errors.currentPass = MyMess.general.errors.requiredPassword
    }

    if (values.mobileNumber && values.mobileNumber.length > 0 ) {
      const phoneNumber = parsePhoneNumber('+'+values.mobileNumber);

      if (!phoneNumber || !phoneNumber.isPossible()) {
          errors.phone = MyMess.general.errors.phone
      }
    } else {
      errors.phone = MyMess.general.errors.phone
    }
    return errors;
  }

  const updateCallback = (setSubmitting, resetForm, resp) => {
    setSubmitting(false);
    setIsProcessing(false);
 
    if (resp && resp.pass) {

      GlobalSnackBarUtil.open({
        message:MyMess.curd.saveSuccess,
        severity:'success'
      })
      resetForm()
        
    //} 
    // else if (resp.error && resp.error === 'invalid_password') {
    //   GlobalSnackBarUtil.open({
    //     message:MyMess.general.errors.currentPassword,
    //     severity:'error'
    //   })
    } else {
        GlobalSnackBarUtil.open({
            message:MyMess.curd.saveFail,
            severity:'error'
        })
    }
  }

  const a11yProps = (index) => {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }

  const handleChange = (event, tabIndex) => {
    setTabIndex(tabIndex);
  };

  // similar to DomainsEditForm,js
  // TODO: refactor to prevent duplicate code
  const getPhoneHelperText = (errorMessage, input, isTouched) => {

    if(!isTouched) {
      return "";
    }

    if (errorMessage) {
        return errorMessage;
    }

    if (input && input.length > 0 ) {

        let phone = input;
        if (!phone.startsWith('+')) {
            phone = '+' + input;
        }

        const phoneNumber = parsePhoneNumber(phone);
        if (phoneNumber && phoneNumber.isPossible()) {
            return `(${phoneNumber.country? phoneNumber.country: 'unknown'}) ${phoneNumber.format("INTERNATIONAL")}`;
        }
    }

    return `${MyMess.general.exampleShort} +852 29616333`;
}

  const _handleSubmit = ({
    values,
    setSubmitting,
    resetForm,
  }) => {
    setIsProcessing(true);

    let changePass = false;

    if(values.currentPass && values.newPass && values.confirmPass) {
      changePass = true;
    }

    let phone = values.mobileNumber;
    if (!phone.startsWith('+')) {
        phone = '+' + values.mobileNumber;
    }

    const phoneNumber = parsePhoneNumber(phone);

    let data = {
      firstName: values.firstName,
      lastName:values.lastName,
      countryCode: phoneNumber ? phoneNumber.countryCallingCode : '',
      tel: phoneNumber ? phoneNumber.nationalNumber : '',
      enableSecondAuth: values.enableSecondAuth,
    };


    if(changePass) {
      dispatch(asyncUpdatePassword(values.currentPass, values.newPass, function(resp){
        if (resp && resp.status === 200) {
          dispatch(asyncEditMerchant({...data,email:merchant.email}, updateCallback.bind(this, setSubmitting, resetForm)));
        } else if (resp.error && resp.error === 'invalid_password') {
          GlobalSnackBarUtil.open({
            message:MyMess.general.errors.currentPassword,
            severity:'error'
          });
          setSubmitting(false);
          setIsProcessing(false);
        } else {
            GlobalSnackBarUtil.open({
                message:MyMess.curd.saveFail,
                severity:'error'
            })
            setSubmitting(false);
            setIsProcessing(false);
        }


      }));
    } else {
      dispatch(asyncEditMerchant({...data,email:merchant.email}, updateCallback.bind(this, setSubmitting, resetForm)));
    }
  }



  // Billing Info
  const validateBillingHandler = (values) => {

    const errors = {};
    ['addr', 'addr2', 'city', 'province', 'zipCodeStr', 'compName'].forEach(key => {

      let field = fields[key];
      let value = values[key];

      if( field &&  field.required && ( !value || value.trim().length === 0 ) ) {
          errors[key] = MyMess.general.errors.required
      } else if (field.maxLength && value && value.length > field.maxLength) {
          errors[key] = MyMess.formatString(MyMess.general.errors.maxLength, fields[key].maxLength )
      } else if (field.isAlphabet && value &&  !isAlphabet(value, true)) {
          errors[key] = MyMess.general.errors.englishOnly
      } else if (field.isAlphanumeric && value &&  !isAlphanumeric(value, true)) {
          errors[key] = MyMess.general.errors.alphanumericOnly
      } else if (field.isAlphanumericWithSymbols && value &&  !isAlphanumericWithSymbols(value, true)) {
          errors[key] = MyMess.general.errors.alphanumericSymbolOnly
      }
      
    });

    if (values.phoneNumber && values.phoneNumber.length > 0 ) {
      const phoneNumber = parsePhoneNumber('+'+values.phoneNumber);

      if (!phoneNumber || !phoneNumber.isPossible()) {
          errors.phone = MyMess.general.errors.phone
      }
    } else {
      errors.phone = MyMess.general.errors.phone
    }
    return errors;
  }

  

  const _handleBillingInfoSubmit = ({
    values,
    setSubmitting,
    resetForm,
  }) => {
    setIsProcessing(true);

    let phone = values.phoneNumber;
    if (!phone.startsWith('+')) {
        phone = '+' + values.phoneNumber;
    }

    const phoneNumber = parsePhoneNumber(phone);
    const country = values.country;

    let data = {
      compName: values.compName,
      addr: values.addr,
      addr2: values.addr2,
      zipCodeStr: values.zipCodeStr,
      city: values.city,
      province: values.province,
      country: country.label,
      countryISO: country.code,
      compCountryCode: phoneNumber ? phoneNumber.countryCallingCode : '',
      compTel: phoneNumber ? phoneNumber.nationalNumber : '',
      email:merchant.email
    };

    dispatch(asyncEditMerchant(data, updateCallback.bind(this, setSubmitting, resetForm)));
  }

  return (
    <React.Fragment>
      <Grid container={true}>
        <Grid item xs={6}>
          <Title>{MyMess.general.account.title}</Title>
        </Grid>  
      </Grid>
      <Grid container={true}>
        <div className={classes.root}>
        <Paper square>
          <Tabs
            value={tabIndex}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            aria-label="full width tabs example"
          >
            <Tab label={MyMess.merchant.basicInfo} {...a11yProps(0)} disabled={isProcessing} />
            <Tab label={MyMess.merchant.billingInfo} {...a11yProps(1)} disabled={isProcessing} />
          </Tabs>

      </Paper>
        <TabPanel value={tabIndex} index={0} dir={theme.direction}>
           
            <Formik
              initialValues={{
                firstName: merchant.firstName,
                lastName:merchant.lastName,
                mobileNumber: parsePhone(merchant.countryCode, merchant.areaCode, merchant.tel),
                enableSecondAuth: merchant.enableSecondAuth,
                currentPass: '',
                newPass: '',
                confirmPass: '',
              }}
              enableReinitialize 
              validate={validateHandler}  
         
          onSubmit={(
              values,
            { setSubmitting, resetForm }
          ) =>
            _handleSubmit({
              values,
              setSubmitting,
              resetForm,
            })
          }
          render={props => {
            const {
              values,
              touched,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              isValid,
              isSubmitting,
              setFieldValue,
              setFieldTouched
            } = props
            return (
              <Paper className={classes.formWrapper} square elevation={3}>
                 <div className={classes.hint}>{MyMess.merchant.basicInfoHint}</div>
                <Form className={classes.form} onSubmit={handleSubmit}>
                <Grid container={true}>
                    <Grid item md={6} style={{paddingLeft: 15, paddingRight: 15, width: '100%'}}>
                      <div className={classes.fieldBox} >
                        <label>{MyMess.general.email}</label>
                        <div className={classes.readonlyField}>
                          {merchant.email}
                        </div>
                      </div>
                      <div className={classes.fieldBox} >
                        <label>{MyMess.merchant.progCode}</label>
                        <div className={classes.readonlyField}>
                          {merchant.progCode}
                        </div>
                      </div>
                      <div className={classes.fieldBox} >
                      <label>{`${MyMess.general.firstName}*`}</label>
                        <Field
                          className={classes.field}
                          variant="outlined"
                          component={TextField}
                          required
                          name="firstName"
                          size="small"
                        />
                      </div>
                      <div className={classes.fieldBox} >
                      <label>{`${MyMess.general.lastName}*`}</label>
                        <Field
                          className={classes.field}
                          variant="outlined"
                          component={TextField}
                          required
                          name="lastName"
                          size="small"
                        />
                      </div>
                      <div className={classes.phoneFieldBox} >
                      <label>{`${MyMess.general.phoneNumber}*`}</label>
                        <Field
                          className={classes.field}
                          name="phone"
                          render={({form, meta}) => 
                              <div className={classes.phoneInputWrapper} >
                                <PhoneInput
                                  disabled={isSubmitting}
                                  country="hk"
                                  placeholder=""
                                  preferredCountries={['hk', 'mo', 'tw' ,'my', 'sg', 'cn']}
                                  value={values.mobileNumber}
                                  onChange={phone => setFieldValue("mobileNumber", phone) && setFieldTouched("phone")}
                                  onBlur={phone => setFieldTouched("phone")}
                                  specialLabel=""
                                  inputProps={{
                                    id:"contact-phone",
                                    name: 'phone',
                                    required: true,
                                    'aria-describedby':"phone-helper-text"
                                  }}
                                />
                                <FormHelperText error={errors.phone} id="phone-helper-text">{getPhoneHelperText(errors.phone, values.mobileNumber, (form.touched.mobileNumber || meta.touched))}</FormHelperText>
                              </div>
                            }
                          />
                      </div>
                    </Grid>

                    <Grid item md={6} style={{paddingLeft: 15, paddingRight: 15, width: '100%'}}>
                      <div className={classes.fieldBox} >
                        <label>{MyMess.general.currentPassword}</label>
                        <Field
                          className={classes.field}
                          variant="outlined"
                          component={TextField}
                          type="password"
                          name="currentPass"
                          size="small"
                        />
                      </div>
                      <div className={classes.fieldBox} >
                        <label>{MyMess.general.newPassword}</label>
                        <Field
                          className={classes.field}
                          variant="outlined"
                          component={TextField}
                          type="password"
                          name="newPass"
                          size="small"
                        />
                      </div>
                      <div className={classes.fieldBox} >
                        <label>{MyMess.general.confirmPassword}</label>
                        <Field
                          className={classes.field}
                          variant="outlined"
                          component={TextField}
                          type="password"
                          name="confirmPass"
                          size="small"
                        />
                      </div>
                      <div className={classes.fieldBox} >
                        <label>{MyMess.merchant.secondAuth}</label>
                        <Field
                          // className={classes.field}
                          component={Switch}
                          name="enableSecondAuth"
                          label="Start"
                          labelPlacement="start"
                         
                          render={(props) => 
                            <div className={classes.field}>
                              <Switch color="primary" {...props}  checked={values.enableSecondAuth} />
                            </div>
                          }
                        />
                      </div>
                    </Grid>
                  </Grid>
                  <Divider />
                  
                  <div style={{display: 'flex', flexDirection: 'row-reverse'}}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      // disabled={Boolean(!isValid || isSubmitting)}
                      disabled={isSubmitting}
                      style={{ margin: '16px' }}
                    >
                      {MyMess.general.save}
                    </Button>
                  </div>
                </Form>
              </Paper>
            )
          }}
        />
          </TabPanel>
          <TabPanel value={tabIndex} index={1} dir={theme.direction}>
          <Formik
          initialValues={{
            compName: merchant.compName,
            addr: merchant.addr,
            addr2: merchant.addr2,
            zipCodeStr: merchant.zipCodeStr,
            city: merchant.city,
            province: merchant.province,
            country: parseCountry(merchant.countryISO, merchant.country),
            phoneNumber: parsePhone(merchant.compCountryCode, merchant.compAreaCode, merchant.compTel),
          }}
          enableReinitialize
          validate={validateBillingHandler}  
         
          onSubmit={(
            values,
            { setSubmitting, resetForm }
          ) =>
          _handleBillingInfoSubmit({
              values,
              setSubmitting,
              resetForm,
            })
          }
          render={props => {
            const {
              values,
              touched,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              isValid,
              isSubmitting,
              setFieldValue,
              setFieldTouched
            } = props
            return (
              <Paper className={classes.formWrapper} square elevation={3}>
                 <div className={classes.hint}>{MyMess.merchant.billingInfoHint}</div>
                <Form className={classes.form} onSubmit={handleSubmit}>
                <Grid container={true}>
                    <Grid item md={6} style={{paddingLeft: 15, paddingRight: 15, width: '100%'}}>
                      
                      <div className={classes.fieldBox} >
                        <label>{`${MyMess.general.companyName}*`}</label>
                        <Field
                          className={classes.field}
                          variant="outlined"
                          component={TextField}
                          required
                          name="compName"
                          size="small"
                        />
                      </div>

                      <div className={classes.fieldBox} >
                        <label>{`${MyMess.general.addr1}*`}</label>
                        <Field
                          className={classes.field}
                          variant="outlined"
                          component={TextField}
                          required
                          name="addr"
                          size="small"
                        />
                      </div>

                      <div className={classes.fieldBox} >
                        <label>{`${MyMess.general.addr2}*`}</label>
                        <Field
                          className={classes.field}
                          variant="outlined"
                          component={TextField}
                          required
                          name="addr2"
                          size="small"
                        />
                      </div>

                      <div className={classes.fieldBox} >
                        <label>{`${MyMess.general.postalCode}*`}</label>
                        <Field
                          className={classes.field}
                          variant="outlined"
                          component={TextField}
                          required
                          name="zipCodeStr"
                          size="small"
                        />
                      </div>
                
                    </Grid>

                    <Grid item md={6} style={{paddingLeft: 15, paddingRight: 15, width: '100%'}}>
                      <div className={classes.fieldBox} >
                        <label>{`${MyMess.general.city}*`}</label>
                        <Field
                          className={classes.field}
                          variant="outlined"
                          component={TextField}
                          required
                          name="city"
                          size="small"
                        />
                      </div>
                      <div className={classes.fieldBox} >
                        <label>{`${MyMess.merchant.province}*`}</label>
                        <Field
                          className={classes.field}
                          variant="outlined"
                          component={TextField}
                          required
                          name="province"
                          size="small"
                        />
                      </div>
                      <div className={classes.fieldBox} >
                        <label>{`${MyMess.general.country}*`}</label>
                        <Field
                          component={Autocomplete}
                          name="country"
                          required
                          label={MyMess.general.country}
                          fullWidth
                          classes={{
                              option: classes.option,
                          }}
                          className={classes.muiTextField}
                          options={countries}
                          getOptionLabel={(option) => option? (  `${option.label} (${option.code})` || ''):''}
                          renderInput={(params) => (
                              <MuiTextField
                                  {...params}
                                  label={MyMess.general.country}
                                  variant="outlined"
                                  helperText={errors['country']}
                                  inputProps={{
                                      required: true,
                                      ...params.inputProps,
                                      autoComplete: 'new-password', // disable autocomplete and autofill
                                  }}
                              />
                          )}
                      />
                      </div>
                      <div className={classes.phoneFieldBox} >
                        <label>{`${MyMess.general.phoneNumber}*`}</label>
                        <Field
                          className={classes.field}
                          name="phone"
                          render={({form, meta}) => 
                              <div className={classes.phoneInputWrapper}>
                                <PhoneInput
                                  country="hk"
                                  placeholder=""
                                  preferredCountries={['hk', 'mo', 'tw' ,'my', 'sg', 'cn']}
                                  value={values.phoneNumber}
                                  onChange={phone => setFieldValue("phoneNumber", phone) && setFieldTouched("phone")}
                                  onBlur={phone => setFieldTouched("phone")}
                                  specialLabel=""
                                  inputProps={{
                                      id:"contact-phone",
                                      name: 'phone',
                                      required: true,
                                      'aria-describedby':"phone-helper-text"
                                  }}
                              />
                              <FormHelperText error={errors.phone} id="phone-helper-text">{getPhoneHelperText(errors.phone, values.phoneNumber, (form.touched.phoneNumber || meta.touched))}</FormHelperText>
                            </div>
                            }
                          />
                      </div>
                    </Grid>
                  </Grid>
                  <Divider />
                  
                  <div style={{display: 'flex', flexDirection: 'row-reverse'}}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      // disabled={Boolean(!isValid || isSubmitting)}
                      disabled={isSubmitting}
                      style={{ margin: '16px' }}
                    >
                      {MyMess.general.save}
                    </Button>
                  </div>
                </Form>
              </Paper>
            )
          }}
        />
          </TabPanel>
        </div>
      </Grid>
     
    </React.Fragment>
  )

};
